import { Component, OnInit } from '@angular/core';
import { DataSourcesService } from '../data-sources.service';
import { MatDivider } from '@angular/material/divider';
import {
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { SeoService } from '../../../../seo/seo.service';
import { dataSourcesPageTags } from '../../../../shared/util/seo-tags';

@Component({
  selector: 'app-data-sources-content',
  templateUrl: './data-sources-content.component.html',
  styleUrls: ['./data-sources-content.component.scss'],
  imports: [
    NgFor,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    NgClass,
    MatDivider,
    NgIf,
  ],
})
export class DataSourcesContentComponent implements OnInit {
  // Frozen at build time on the prerendered page, like the sales-forecast
  // pages' copy; corrected after hydration.
  public readonly yearsOfExperience = new Date().getFullYear() - 2016;

  constructor(
    public dataSourcesService: DataSourcesService,
    private seo: SeoService
  ) {}

  // Here rather than in DataInfoComponent: the shell outlives switching
  // between the info pages, and each page needs its own canonical.
  ngOnInit(): void {
    this.seo.applyPageSeo(dataSourcesPageTags);
  }
}
